import React from 'react';
import { AspectRatio, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader } from '@chakra-ui/react';
import TechLibraryFiles from '../pdf/tech-library-file';
import TechLibraryVideoPlayer from './TechLibraryVideoPlayer';

const TechLibraryViewerModal = ({ isOpen, onClose, info }) => {
  const isYoutube = info?.mediaType === 'youtube';
  const isFirebaseVideo = info?.mediaType === 'video';

  return (
    <Modal size="full" isOpen={isOpen} onClose={onClose} className="m-4">
      <ModalContent className="my-0 ">
        <ModalHeader className="font-bold text-white bg-blue font-heading" style={{ fontSize: '1.2em' }}>
          {info?.title}
        </ModalHeader>
        <ModalCloseButton color="white" style={{ fontSize: '24px' }} />
        <ModalBody className="flex justify-center content-center h-full p-0 m-0">
          {info?.pdfLink && isYoutube && (
            <AspectRatio ratio={16 / 9} width="100%">
              <iframe
                src={info.pdfLink}
                title="YouTube video"
                allow="autoplay; encrypted-media"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </AspectRatio>
          )}
          {info?.pdfLink && isFirebaseVideo && <TechLibraryVideoPlayer url={info.pdfLink} />}
          {info?.pdfLink && !isYoutube && !isFirebaseVideo && <TechLibraryFiles url={info.pdfLink} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TechLibraryViewerModal;
